import * as React from "react";

import {
  Button,
  ButtonDownIcon,
  ButtonIconContainer,
  ButtonUpIcon,
} from "./button.js";
import { useLocalization } from "gatsby-theme-i18n";

const translations = {
  en: {
    up: "less",
    down: "more",
  },
  zh: {
    up: "顯示較少",
    down: "了解更多",
  },
};

const ToggleButton = ({ isActive, setIsActive }) => {
  const { locale } = useLocalization();
  const translation = translations[locale];

  return (
    <Button
      onClick={() => {
        setIsActive(!isActive);
      }}
    >
      <ButtonIconContainer>
        {isActive ? <ButtonUpIcon size={18} /> : <ButtonDownIcon size={18} />}
      </ButtonIconContainer>
      {isActive ? translation.up : translation.down}
    </Button>
  );
};

export default ToggleButton;
